/**
 * File sizes, as the design writes them.
 *
 * Bytes below a kilobyte, whole kilobytes below a megabyte, and megabytes to
 * one decimal with a Norwegian comma — decision 8's rule for numbers applies to
 * a file size as much as to a share count.
 *
 * Deliberately not a general-purpose byte formatter: no gigabytes, because a
 * gigabyte does not belong on a share register, and a size that reads
 * "1024,0 MB" is a sign something is wrong rather than a formatting gap.
 */
export function fmtFileSize(bytes: number): string {
  const n = Number(bytes) || 0
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`
  return `${(n / 1048576).toFixed(1).replace('.', ',')} MB`
}
